import React from "react";
import "./select.styles.css";

import {IonLabel, IonItem, IonSelect, IonSelectOption} from "@ionic/react";
import {ErrorMessage} from "@hookform/error-message";

interface IOption {
  value: string;
  display: string;
}
interface ISelect {
  register: any;
  errors: any;
  registerName: string;
  name: string;
  pattern?: {
    value: RegExp | string;
    message: string;
  };
  requiredMessage?: string | false;
  options: IOption[];
  multiple?: boolean;
  validate?: any;
  disabled?: boolean;
  required?: boolean;

  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const Select = ({
  register,
  errors,
  registerName,
  name,
  pattern,
  requiredMessage,
  options,
  multiple,
  validate,
  disabled,
  required,

  onChange,
}: ISelect) => {
  return (
    <div className="app-select-wrapper">
      <div className="select-field-label">
        <IonLabel className="select-label-text">{name}</IonLabel>
        {required && (
          <span
            style={{
              color: "red",
            }}
          >
            *
          </span>
        )}
      </div>
      <IonItem>
        <IonSelect
          className="app-select-field"
          disabled={disabled}
          multiple={multiple}
          {...register(registerName, {
            validate: validate,
            required: requiredMessage,
            pattern: {
              value: pattern && pattern.value,
              message: pattern && pattern.message,
            },
          })}
          onIonChange={onChange}
        >
          {options.map((option: IOption, index: number) => (
            <IonSelectOption value={option.value} key={index}>
              {option.display}
            </IonSelectOption>
          ))}
        </IonSelect>
      </IonItem>

      <ErrorMessage errors={errors} name={registerName} as={"span"} />
    </div>
  );
};

Select.defaultProps = {
  multiple: false,
};

export default Select;
